import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import { getExtendedPropertyUri } from 'owa-service/lib/Utils';
import ExtendedPropertyUri from 'owa-service/lib/contract/ExtendedPropertyUri';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import { ComposeViewState } from 'owa-mail-compose-store';
import { InternetHeaders } from 'owa-addins-core';
import { Message } from 'owa-mail-compose-store';
import setInternetHeaders from 'owa-mail-compose-store/lib/actions/setInternetHeaders';
import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';

const PS_INTERNET_HEADERS_GUID = '00020386-0000-0000-C000-000000000046';

export async function updateViewStateWithAnyMissingHeaders(
    viewState: ComposeViewState,
    headerNames: string[]
) {
    let headers: InternetHeaders;
    const keysOfHeadersToGetFromItem: string[] = [];
    headerNames.forEach(name => {
        if (!viewState.internetHeaders.get(name)) {
            keysOfHeadersToGetFromItem.push(name);
        }
    });
    if (keysOfHeadersToGetFromItem.length > 0) {
        headers = await tryGetHeaders(keysOfHeadersToGetFromItem, viewState.itemId.Id);
        setInternetHeaders(viewState, headers);
    }
}

export async function tryGetHeaders(headerNames: string[], id: string): Promise<InternetHeaders> {
    const itemShape = itemResponseShape({
        BaseShape: 'IdOnly',
        AdditionalProperties: createExtendedPropertyUrisForInternetHeaders(headerNames),
    });

    let nameValuePairs: InternetHeaders = {};
    try {
        const response: SingleResponseMessage[] = await getItem(
            [id],
            itemShape,
            null /* shapeName */
        );
        if (checkIfResponseSuccess(response[0])) {
            const responseMessage = response[0] as ItemInfoResponseMessage;
            const message = responseMessage.Items[0] as Message;
            if (message.ExtendedProperty) {
                nameValuePairs = convertArrayToNameValuePairs(message.ExtendedProperty);
            }
        }
    } catch (error) {
        throw error;
    }

    return nameValuePairs;
}

function convertArrayToNameValuePairs(extendedProperties: ExtendedPropertyType[]): InternetHeaders {
    return extendedProperties.reduce(
        (dictionary, extendedProperty) => {
            dictionary[extendedProperty.ExtendedFieldURI.PropertyName] = extendedProperty.Value;
            return dictionary;
        },
        {} as InternetHeaders
    );
}

function createExtendedPropertyUrisForInternetHeaders(
    headerNames: string[]
): ExtendedPropertyUri[] {
    const uris: ExtendedPropertyUri[] = [];
    headerNames.forEach(name => {
        uris.push(getExtendedPropertyUri(PS_INTERNET_HEADERS_GUID, name, 'String'));
    });
    return uris;
}
